import * as sup from "superstruct";

import { createResourceStruct } from "@/modules/api/utils/jsonApiStructs";

import { companyIdentifierStruct } from "./companyIdentifierStruct";

export const userRoles = sup.union([
  sup.literal("OWNER"),
  sup.literal("ADMIN"),
  sup.literal("EMPLOYEE"),
]);

export const companyResourceStruct = createResourceStruct({
  identifier: companyIdentifierStruct,
  attributes: sup.object({
    name: sup.string(),
  }),
  meta: sup.object({
    access: sup.array(userRoles),
  }),
});

export type UserRoles = sup.Infer<typeof userRoles>;
